import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material';
import AlertLivenessSourcesSettings from './AlertLivenessSourcesSettings';

const LS_KEY = 'shifty.showAlertsOnOverview';

export function readShowAlertsOnOverview() {
  try {
    return localStorage.getItem(LS_KEY) !== '0';
  } catch {
    return true;
  }
}

export function writeShowAlertsOnOverview(value) {
  try {
    localStorage.setItem(LS_KEY, value ? '1' : '0');
  } catch {
    /* ignore */
  }
}

/**
 * In-app alert display preferences (stored locally for now).
 */
export default function AlertNotificationSettingsDialog({
  open,
  onClose,
  showAlertsOnOverview,
  onChangeShowAlertsOnOverview,
  userData,
}) {
  const showLiveness = Boolean(
    userData?.companyId && ['company_admin', 'developer'].includes(userData?.role),
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" scroll="paper">
      <DialogTitle>Notification settings</DialogTitle>
      <DialogContent dividers sx={{ maxHeight: 'min(70vh, 560px)' }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Notifications are broadcast by your platform team. You can read, archive, and filter them from the bell menu
          or Settings → Notifications.
        </Typography>
        {userData?.companyId && (
          <>
            <FormControlLabel
              control={
                <Switch
                  checked={showAlertsOnOverview}
                  onChange={(_, checked) => onChangeShowAlertsOnOverview(checked)}
                />
              }
              label="Show Notifications section on Overview"
            />
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1, ml: 4.5 }}>
              Turn off to hide the collapsible Notifications block on the home dashboard. The bell menu is unchanged.
            </Typography>
          </>
        )}

        {showLiveness && (
          <>
            <Divider sx={{ my: 3 }} />
            <AlertLivenessSourcesSettings userData={userData} compact />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
